<template>
  <div
    v-if="modal.open"
    class="modal-backdrop"
    @click.self="close('productModal')"
  >
    <div class="modal-content animated fade-in">
      <div class="d-flex justify-content-right gap-2 align-items-center">
        <button class="btn" @click="close"><i class="bi  bi-x"></i></button>
        <button class="btn" @click="goProductPage(item.id)"><i class="bi bi-share"></i></button>
      </div>

      <div class="product-template" v-if="item">
        <div class="product-template-image">
          <product-slider :images="item.image_url.split(',')" v-if="item.image_url" />
        </div>
        <div class="product-template-info">
          <div class="p-2 w-100">
            <h3 class="mb-2">{{ item.stuff_name }}</h3>
            <div
              v-html="item.main_description"
              style="text-align: justify; font-size: 15px"
              v-if="item.main_description"
            ></div>
            <div
              v-html="item.description"
              class="text-muted"
              style="text-align: justify; font-size: 15px;max-height: 45px;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;display: -webkit-box;-webkit-box-orient: vertical;"
              v-else
            ></div>
            <p v-if="item.discount > 0" class="mb-0">
              <span class="item_price pt-2">
                <div class="d-flex align-items-center">
                  <del class="d-block">{{ convertToPersian(item.price) }}</del>
                  <label
                    class="text-danger mr-1 product-discount"
                    :class="{ 'peculiar-discount': item.discount > 4 }"
                    >%{{ convertToPersian(item.discount) }}</label
                  >
                </div>
                <strong>
                  {{
                    convertToPersian(
                      numberFormat(
                        parseInt(item.price.replaceAll(",", "")) -
                          parseInt(item.price.replaceAll(",", "")) *
                            (parseInt(item.discount) / 100)
                      )
                    )
                  }}
                </strong>
              </span>
              تومان
            </p>
            <p v-else class="mb-0 pt-2">
              <strong class="item_price">{{
                convertToPersian(item.price)
              }}</strong>
              تومان
            </p>
          </div>
          <div
            style="position: relative !important; width: 11em"
            v-if="item.close != 1"
          >
            <button-template
              :id="item.id"
              :sid="item.store_place_id"
              :flag="`popup`"
              :quantity="item.quantity"
              origin="product"
            />
          </div>
          <div v-else>
            <button class="btn btn-secondary" disabled>فروشگاه بسته است</button>
            <br />
            <small class="d-block mt-3"
              >فروشگاه در حال حاضر بسته است، لطفا لحظاتی بعد تلاش کنید</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import ButtonTemplate from "../item/button.vue";
import ProductSlider from "../item/productSlider.vue";
import { computed, onMounted, ref, watch } from "vue";
import { useModal } from "@/store/modal.js";
import { convertToPersian, numberFormat } from "@/composables/digits";
import router from '@/router';
const modalStore = useModal();
const item = ref();
const modal = computed(() =>
  modalStore.modals.find((m) => m.name == "productModal")
);
watch(
  () => modal.value?.open,
  (newVal) => {
    if (newVal) {
      showProduct();
    }
  }
);
async function showProduct() {
  let response = await fetch(
    `https://radap.ir/Backend/api/section/pages/product/get.php?id=${modalStore.paylode.id}`
  );
  let data = await response.json();
  item.value = data;
}

function close() {
  modalStore.close("productModal");
}
function goProductPage(id){
  close()
  router.push({name:'Single',params:{item:id}})
}
</script>
<style scoped>
.animated {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal styles */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background: white;
  /* padding: 1rem 1rem 3.5rem 1rem; */
  padding: 1rem;
  border-radius: 0.5rem;
  position: relative;
  max-width: 500px;
  width: 90%;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgb(0 0 0 / 13%) 0px 0px 1px 1px;
}


.hZkLjq{
	    position: inherit !important;
		display: block;
}
.occasion-cart{
	position: relative !important;
	margin-bottom: 60px;
    height: 0px;

}
.product-template-info{
	display: flex;
	justify-content: space-between;
	align-items: start !important;
	flex-direction: column !important;
}
img{
	border-radius: .5em;
	width: 425px;
}
.product-template-image{

	text-align: center
}
.product-discount{
    border: 1px solid red;
    line-height: 1.1;
    font-size: 12px;
    font-weight: 700;
    border-radius: 4px;
	background: red !important;
	color: white !important;
	font-family: 'IranSans';
}

</style>
